<template>
  <!-- 走进武夷山 -->
  <div>
    <div style="position:relative">
      <TopButtom
        v-bind:buttonlist="buttonlist"
        v-on:changeDataList="changeDataList"
      ></TopButtom>
    </div>
    <div class="tabpage">
      <div class="rowA">
        <div class="english">KNOWLEDGE</div>
        <div class="chinese">走进武夷山</div>
      </div>
      <div class="rowB">
        <div class="topTitle">
          <div style="margin-left:1.042vw">全国首批国家公园</div>
          <div style="margin-left:1.042vw">省级非物质文化遗产</div>
          <div style="margin-left:1.042vw">国家5A级旅游景区</div>
          <div style="margin-left:1.042vw">省级非物质文化遗产</div>
          <div style="margin-left:1.042vw">全国旅游系统先进集体</div>
          <div style="margin-left:1.042vw">中国网民最关注的十大旅游景区</div>
          <div style="margin-left:1.042vw">全国文明风景旅游区</div>
          <div style="margin-left:1.042vw">中国人居环境范例奖</div>
        </div>
        <div class="body">
          <div class="leftBody">
            <div style="display: flex;flex-direction: row;justify-content: center;font-size: 1.296vh;font-family: 'Microsoft YaHei'; font-weight: 400;  color: #005a51;text-align: center;">
              <span>阅读次数: {{info.hits}}</span>
            </div>
            <div v-html="info.details" class="leftBodyFont"> </div>
          </div>
          <div class="rightBody">
            <img :src="info.url" class="middleImg" />
          </div>
        </div>
      </div>
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh">天下难寻</div>
            <div style="margin-top:1.018vh">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMenuOpenList } from "@/api/publicApi";
import  {addHits}  from "@/util/publicHits";
import TopButtom from "@/components/common/TopButtom.vue";
export default {
  name: "TabApage",
  components: { TopButtom },
  data() {
    return {
      info: {},
      buttonlist: [
        {
          id: 1,
          leftS: "left:1.5625vw",
          leftX: "left:1.458vw",
          title: "走进武夷山",
          noCheckX: false
        },
        {
          id: 2,
          leftS: "left:10.5208vw",
          leftX: "left:10.4167vw",
          title: "景区景点",
          noCheckX: true
        },
        // {
        //   id: 3,
        //   leftS: "left:19.479vw",
        //   leftX: "left:19.375vw",
        //   title: "武夷山规划",
        //   noCheckX: true
        // },
        // {
        //   id: 4,
        //   leftS: "left:28.4375vw",
        //   leftX: "left:28.333vw",
        //   title: "地址演变",
        //   noCheckX: true
        // }
      ]
    };
  },
  mounted() {
    this.getAboutInfoFunction();
  },
  methods: {
    //首页概括获取 pId,type,current,pageSize
    async getAboutInfoFunction(type) {
      const { code, data } = await getMenuOpenList(0,'about_info',1,1); //特殊原因 只处理最新的那一条数据 业务如此 接口或者数据结构可以优化
      if (code == 200) {
        var newData = data.records
        if (newData.length > 0) {
          let BASE_URL = this.Global;
          newData.forEach(function(element) {
            element.url != null  ? (element.url = `${BASE_URL}${element.url}`) : "";
          });
          console.log('hits:',this.info)
          this.info = data.records[0];
          console.log('hits:',this.info.hits)
          addHits(this.info.id)
        }
      }
    },
    //切换标签
    changeDataList(type) {
      let name = "";
      if (type == 1) {
        name = "TabApage";
      } else if (type == 2) {
        name = "TabBpage";
      } else if (type == 3) {
        name = "TabCpage";
      } else if (type == 4) {
        name = "TabDpage";
      }
      this.$store.commit("setTabPage", type);
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>
.tabpage {
  height: 85.555vh;
  background: url(../../assets/image/logoBottom.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}
.tabpage .rowA {
  display: flex;
  flex-direction: row;
  margin-top: 6%;
  margin-left: 9.67%;
}
.tabpage .rowB {
  width: 100%;
  margin-top: 3.2407vh;
  position: relative;
  display: flex;
  flex-direction: column;

  /* margin-left: 4.24%; */
}
.tabpage .rowB .topTitle {
  font-size: 1.296vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #666666;
  writing-mode: vertical-rl;
  position: absolute;
  z-index: 2;
  right: 1.041vw;
  animation: bounceInTop 2s;
}
.tabpage .rowB .body {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  z-index: 2;
  top: 30.462vh;
  animation: bounceInRight 2s;
}

.tabpage .rowB .body .leftBody {
  width: 49%;
  height: 46.111vh;
  overflow-y: scroll;
  font-size: 1.296vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #666666;
  text-indent: 2em;
}
.tabpage .rowB .body .leftBody .leftBodyFont {
  width: 95%;
  line-height:30px
  /* line-height: 2.77vh; */
}

.tabpage .rowC {
  padding: 0px 0.3645vw 0px 0.3645vw;
  height: 26.481vh;
  line-height: 1.574vh;
  background: #d87001;
  color: #ffffff;
  margin-top: 2.6851vh;
  margin-left: 6.8%;
  margin-right: 1.04167vw;
  animation: bounceInTop 2s;
  font-size: 1.2962vh;
}
.tabpage .rowB .topFont {
  font-size: 1.66667vh;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #333333;
  line-height: 1.66667vh;
  margin-bottom: 1.388vh;
}
.tabpage .chinese {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  margin-left: 0.833vh;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
.tabpage .english {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}

.leftBody::-webkit-scrollbar {
  width: 8px;
  /*height: 4px;*/
}
/* 滑块 */
.leftBody::-webkit-scrollbar-thumb {
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #ababab;
}
/* 滑槽 */
.leftBody::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
  background: #e6e6e6;
}
.middleImg {
  width: 33.0208vw;
  height: 46.1111vh;
  transition: all 0.6s;
}
.middleImg:hover {
  transform: scale(1.4);
}
.rightBody {
  width: 33.0208vw;
  height: 46.1111vh;
  overflow: hidden;
  margin-left: 2.34375vw;
  cursor: pointer;
}
.outlineImgSize {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 33.0208vw;
  height: 46.1111vh;
  margin-left: 2.34375vw;
}
.outlineImgSize:hover {
  background-size: 110% 110%;
}
</style>



// WEBPACK FOOTER //
// src/views/outline/tabApage.vue